// services/functions/revokeUnlockCode.ts — typed wrapper around the
// revokeUnlockCode callable. Flips an unlock code's stored status to
// 'revoked' so future redeemUnlockCode calls fail. Existing
// entitlements are NOT unwound (the dashboard surfaces this in copy).

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface Input {
  /** 12-char hex prefix, same shape returned by listRecentUnlockCodes. */
  codeHashPrefix: string;
  /** Optional admin note (capped at 500 chars server-side). */
  reason?: string;
}

interface Output {
  codeHashPrefix: string;
  status: 'revoked';
  /** True if the code was already revoked - the call is idempotent. */
  alreadyRevoked: boolean;
}

const callable = httpsCallable<Input, Output>(functions, 'revokeUnlockCode');

export async function revokeUnlockCode(input: Input): Promise<Output> {
  const res = await callable(input);
  return res.data;
}
